<div *ngIf="qsForm" [formGroup]="qsForm" data-question-medical-workflow="" data-question="question" class="grid-container ng-isolate-scope">
    <div>
        <!-- Height/Weight question. -->
        <!-- ngIf: question.heightWeight -->
        <!-- Simple/Complex question. -->
        <!-- ngIf: question.simpleOrComplex -->
        <div data-ng-if="question.simpleOrComplex" class="ng-scope">
            <!-- ngIf: !!question.preamble -->
            <div class="list-digit__target grid-container">
                <div class="grid-9 grid-mobile-4">
                    <!-- ngIf: !!title -->
                </div>
                <div class="grid-12 grid-mobile-4 grid-container">
                    <div class="grid-9 grid-mobile-4 question-title" [innerHTML]="questionQuestionnaireSante.libelle"></div>
                    <div class="grid-3 grid-mobile-4 grid-container buttons">
                        <div class="yesNo-button grid-4 push-3 push-mobile-0">
                            <span class="choice-box choice-box--buttonFull">
                                <input
                                    class="choice--button"
                                    type="radio"
                                    [formControlName]="questionQuestionnaireSante.numero"
                                    [id]="questionQuestionnaireSante.numero + 'No'"
                                    [attr.name]="questionQuestionnaireSante.numero"
                                    required
                                    [value]="false"
                                    (change)="hideExtraPanel()"
                                />
                                <label class="choice-box__label choice-box__label--button" [for]="questionQuestionnaireSante.numero + 'No'">
                                    {{ 'medicalworkflow.question.no' | i18n }}
                                </label>
                            </span>
                        </div>
                        <div class="yesNo-button grid-4 push-4 push-mobile-0 float-mobile-right">
                            <span class="choice-box choice-box--buttonFull">
                                <input
                                    class="choice--button"
                                    type="radio"
                                    [formControlName]="questionQuestionnaireSante.numero"
                                    [id]="questionQuestionnaireSante.numero + 'Yes'"
                                    [attr.name]="questionQuestionnaireSante.numero"
                                    required
                                    [value]="true"
                                    (change)="showExtraPanel()"
                                />
                                <label class="choice-box__label choice-box__label--button" [for]="questionQuestionnaireSante.numero + 'Yes'">
                                    {{ 'medicalworkflow.question.yes' | i18n }}
                                </label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ngIf: question.complexAndHasPositiveAnswer() -->
            <div [hidden]="!extraPanelVisible" class="complex-question ng-scope" data-ng-if="question.complexAndHasPositiveAnswer()">
                <div class="complex-question__intro hide-mobile ng-binding">
                    {{ 'medicalworkflow.question.mandatoryFields' | i18n }}
                </div>
                <!-- ngIf: question.complexAndHasPositiveAnswerAndHasSubanswers() -->
                <div class="sub-questions ng-scope" data-ng-if="question.complexAndHasPositiveAnswerAndHasSubanswers()">
                    <!-- ngRepeat: subAnswer in question.answers.subAnswers track by $index -->
                    <app-motif-component
                        *ngFor="let motif of motifs"
                        [qsForm]="qsForm"
                        [questionQuestionnaireSante]="questionQuestionnaireSante"
                        [controlId]="motif.controlId"
                        [controlsEnable]="extraPanelVisible"
                        (removeMotifEvent)="removeMotif(motif)"
                        [charCounter]="charCounter"
                        [maxCharCounter]="maxCharCounter"
                        (valuesChanged)="updateCharCounter()"
                    >
                    </app-motif-component>
                </div>
                <!-- end ngIf: question.complexAndHasPositiveAnswerAndHasSubanswers() -->

                <button
                    type="button"
                    class="button button--primary button--fullwidth-mobile centered-mobile ng-binding"
                    data-tag-commander=""
                    [appTagCommander]="'tagCo.qs.question.addsubanswer.button'"
                    data-ng-class="{'button--fullwidth':isMobile}"
                    (click)="addMotif()"
                >
                    {{ 'medicalworkflow.question.addReason' | i18n }}
                </button>
                <div class="complex-question__intro hide show-mobile ng-binding">
                    {{ 'medicalworkflow.question.mandatoryFields' | i18n }}
                </div>
            </div>
            <!-- end ngIf: question.complexAndHasPositiveAnswer() -->
        </div>
        <!-- end ngIf: question.simpleOrComplex -->
    </div>
</div>
